import { unref } from 'vue'
import { type Graph, Cell } from '@antv/x6'
import { NodeType } from '@/enums/flow'
import { getParentIdByNodeId, getSuperiorNode } from './utils'
// graph 侦听器
export function createGraphListener(
  graph: Graph | undefined,
  flowConfigData: any,
  currentNodeId: any,
  disabled: boolean = false
): void {
  graph!.on('node:click', ({ cell }) => {
    const { id: nodeId } = cell.toJSON()
    if (cell.data?.type === 'STRUCT' || cell.shape === 'flow-result') return
    // 修改flowConfigData
    flowConfigData.value = {
      isNode: graph!.isNode(cell),
      isEdge: graph!.isEdge(cell),
      nodeId,
      ...cell.getData()
    }
    if (currentNodeId) {
      currentNodeId.value = ''
      setTimeout(() => {
        currentNodeId.value = nodeId
      })
    }
    // 高亮
    const allEdgs = unref(graph)!.getEdges()
    const edges = unref(graph)!.getConnectedEdges(cell)
    allEdgs.forEach(edge => edge.attr('line/stroke', '#aaaaaa'))
    edges.forEach(edge => {
      edge.attr('line/stroke', '#5687FF')
    })
  })
  graph!.on('edge:click', ({ cell }) => {
    const { id: edgeId } = cell.toJSON()
    if (currentNodeId) {
      currentNodeId.value = edgeId
    }
    flowConfigData.value = {
      isNode: graph!.isNode(cell),
      isEdge: graph!.isEdge(cell),
      edgeId,
      ...cell.getData()
    }
  })

  graph!.on('cell:removed', () => {
    flowConfigData.value = {}
  })

  graph!.bindKey('ctrl+z', () => {
    graph?.undo()
  })
  graph!.bindKey('ctrl+y', () => {
    graph?.redo()
  })
  graph!.on('blank:mousedown', () => {
    // 查看审批结果
    if (disabled) return
    const edges = unref(graph)!.getEdges()
    edges.forEach(edge => {
      edge.attr('line/stroke', '#aaaaaa')
    })
    flowConfigData.value = {}
  })

  graph!.on('edge:connected', ({ edge, isNew }) => {
    if (isNew) {
      const { target, source }: any = edge
      const targetNode = graph?.getCellById(target.cell) as Cell
      const sourceNode = graph?.getCellById(source.cell) as Cell
      const targetData = targetNode.getData()
      const sourceData = sourceNode.getData()
      // 同级节点只支持业务节点连接
      if (targetData.type === NodeType.PEER && sourceData.type !== NodeType.BUSINESS) {
        ElMessage.error('同级节点只支持业务节点连接！')
        graph?.removeEdge(edge.id)
        return
      }
      // 同级节点只能有一个上级
      if (targetData.type === NodeType.PEER) {
        const parentIds = getParentIdByNodeId(graph as Graph, targetNode.id)
        if (parentIds.length > 1) {
          ElMessage.error('同级节点只能有一个上级！')
          graph?.removeEdge(edge.id)
          return
        }
      }
      // 业务流程中节点不能反连上级 上上级
      const parentIds = getSuperiorNode(graph as Graph, sourceNode.id, edge.id)
      if (parentIds.includes(targetNode.id)) {
        ElMessage.error('不能反连自己的上级或上上级！')
        graph?.removeEdge(edge.id)
        return
      }
      // 开始节点不能当作目标节点，结束节点不能当作起始节点
      if (targetData.type === NodeType.STRUCT && targetData.flag === 'START') {
        ElMessage.error('不能反连开始节点！')
        graph?.removeEdge(edge.id)
        return
      }
      if (sourceData.type === NodeType.STRUCT && sourceData.flag === 'END') {
        ElMessage.error('不能反连结束节点！')
        graph?.removeEdge(edge.id)
        return
      }
      // 业务流程中开始节点仅能连接默认节点
      if (targetData.type !== NodeType.APPROVAL) {
        if (sourceData.type === NodeType.STRUCT && targetData.type === NodeType.STRUCT) {
          graph?.removeEdge(edge.id)
        } else if (sourceData.type === NodeType.STRUCT && !targetData.isRoot) {
          ElMessage.error('开始节点仅能连接默认节点，不可连接其他节点！')
          graph?.removeEdge(edge.id)
        }
      }
      currentNodeId.value = ''
    }
  })
  graph!.on('node:added', ({ node }) => {
    const data = node.getData()
    // 子流程最多只能添加10个
    if (data.type === NodeType.CHILD) {
      const nodes = graph!.getNodes() || []
      let childNodeLength = 0
      nodes.forEach(item => {
        const nodeData = item.getData()
        if (nodeData.type === NodeType.CHILD) childNodeLength += 1
      })
      if (childNodeLength > 10) {
        ElMessage.error('暂不支持配置10个以上的子流程!')
        graph?.removeNode(node.id)
      }
    }
  })
  graph!.on('edge:added', ({ edge }) => {
    const edges = unref(graph)!.getEdges()
    // 新创建的边 添加默认值（名称、排序、是否默认、label） 名称可能重复
    const numList: string[] = []
    let def = true
    edges.forEach((item: any) => {
      numList.push(item.data?.name?.replace('线', ''))
      if (item.id !== edge.id && item.getSourceCellId() === edge.getSourceCellId()) def = false
    })
    for (let i = 1; i < 1000; i++) {
      if (!numList.includes(i + '')) {
        edge.data.name = `线${i}`
        edge.data.order = i
        edge.data.def = def // 如果不存在同一个起始节点的线，默认就是ture
        edge.setLabels(`线${i}`)
        return
      }
    }
  })
}
